import React from 'react';
import ModalSellerLocationV3 from 'components/Modals/ModalSellerLocationV3';
import { UserDataInterface } from 'interface/reducers/auth';

interface IModalSelectLocationProps {
  userData: UserDataInterface;
  isOpen: boolean;
  locationSubmitted: boolean;
  countrySelected: any;
  countryList: any;
  provinceSelected: any;
  provinceList: any;
  errorLocation: any;
  toggleModalSellerLocation: () => void;
  handleCountryChange: (param) => void;
  handleProvinceChange: (param) => void;
  onSubmitLocation: () => void;
}

const ModalSelectLocation: React.FC<IModalSelectLocationProps> = (props) => {
  const {
    userData,
    isOpen,
    locationSubmitted,
    countryList,
    countrySelected,
    provinceList,
    provinceSelected,
    errorLocation,
    toggleModalSellerLocation,
    handleCountryChange,
    handleProvinceChange,
    onSubmitLocation,
  } = props;
  
  return (
    <ModalSellerLocationV3
      isOpen={isOpen}
      onToggle={toggleModalSellerLocation}
      countryLocation={userData?.country_code}
      sellerLocation={userData?.user_setting?.seller_location_id}
      countryName={'countrySelected'}
      onChangeCountry={handleCountryChange}
      countryValue={countrySelected}
      countryOptions={countryList}
      name={'provinceSelected'}
      onChange={handleProvinceChange}
      value={provinceSelected}
      options={provinceList}
      onClick={onSubmitLocation}
      isSubmitted={locationSubmitted}
      errorProvince={
        errorLocation != null && errorLocation.status_code === 422
          ? errorLocation.errors.provinceSelected
          : undefined
      }
      errorCountry={
        errorLocation != null && errorLocation.status_code === 422
          ? errorLocation.errors.countrySelected
          : undefined
      }
    />
  );
};

export default ModalSelectLocation;
